import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'

interface UseReviewCompanyGovernmentAllocationEntryProps {
  governmentAllocationId?: string
  state?: string
  onSuccess?: () => void
  onError?: (error: ErrorResponse) => void
}

export const useReviewCompanyGovernmentAllocationEntry = ({
  governmentAllocationId,
  state,
  onSuccess,
  onError,
}: UseReviewCompanyGovernmentAllocationEntryProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['reviewCompanyGovernmentAllocationEntry'],
    mutationFn: async (data?: { description?: string }) => {
      const government_allocation_entry = {
        last_review_attributes: {
          state,
          description: data?.description,
        },
      }

      await privateAxios.put(`/billing/government_allocation_entries/${governmentAllocationId}`, {
        government_allocation_entry,
      })
    },
    onSuccess,
    onError,
  })
}
